import React, { useState, useEffect } from 'react';
import Page from "../../pages/Page";
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import { useParams } from 'react-router-dom'
import { getApi } from '../../api/endpoints';
import RentalCustomer from '../../models/RentalCustomer'
import RentalBooking from '../../models/RentalBooking'
import { toast } from 'react-toastify';
import DetailsComponent from "../../components/DetailsComponent";
import { Row, Col } from "react-bootstrap";
import TabsComponent from '../../components/TabsComponent'
import CustomerBatteryTransactionListing from '../battery_transactions/CustomerBatteryTransactionListing'
import RentalBookingListing from '../rental_bookings/Listing'
import WalletTransactionsListing from '../wallet_transactions/Listing'

const Show = () => {
  const [fetchApi] = getApi('RentalCustomerDetails');
  const [rentalCustomerDetails, setRentalCustomerDetails] = useState(new RentalCustomer().toStateJson());
  const [rentalBookingDetails, setRentalBookingDetails] = useState({});
  const params = useParams();
  const [tabs, setTabs] = useState([
    {
      event: 'battery_swaps',
      heading: 'Battery Swaps List',
      component: <CustomerBatteryTransactionListing params={{ user_id: params.id }} />,
      ui_action: 'view_rental_battery_swaps_tab'
    },
    {
      event: 'rental_bookings',
      heading: 'Rental Bookings List',
      component: <><RentalBookingListing params={{ rental_customer_id: params.id }} /></>,
      ui_action: 'view_rental_bookings_tab'
    },
    {
      event: 'wallet_transactions',
      heading: 'Wallet Transactions List',
      component: <><WalletTransactionsListing params={{ user_id: params.id }} /></>,
      ui_action: 'view_rental_customer_wallet_transactions_tab'
    }
  ])

  useEffect(()=> {
    getRecord();
  }, [])

  const getRecord = async () => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setRentalCustomerDetails((new RentalCustomer(response.data.rental_customer)).toStateJson());
      if(response.data.rental_customer?.rental_booking) {
        setRentalBookingDetails((new RentalBooking(response.data.rental_customer?.rental_booking)).toStateJson());
      } 
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong");
    }
  }
  return <Page
    uiPage={uiManager.getUiPage(PAGES.ShowRentalCustomerPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Rental Customers", url: '/rental_customers' }, { label: `${params.id}` }]}
    className={'rental-customer-show-page'}
  >
    <PageContentWrapper contentHeading={'Rental Customer Details'}>
      <DetailsComponent data={rentalCustomerDetails} />
      {Object.keys(rentalBookingDetails).length > 0  &&<> <Row>
        <Col>
          <h4 className="border-bottom pb-2 pt-2" style={{ margin: 0 }}>
            Current Booking Details
          </h4>
        </Col>
      </Row>
      <DetailsComponent data={rentalBookingDetails} /></>}
      <TabsComponent defaultActiveEvent={'battery_swaps'} data={tabs} />
    </PageContentWrapper>
  </Page>
};

export default Show;
